import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useStoreGate } from '@/contexts/StoreGateContext'
import { shouldRedirectToLaunchPage } from '@/lib/launchGate'
import { StorePageLoader } from '@/store/components/StorePageLoader'

/** Redirects storefront routes to `/launch` while the launch gate is active. */
export function StoreLaunchGate() {
  const { settings, status } = useStoreGate()
  const location = useLocation()

  if (status === 'loading') {
    return <StorePageLoader />
  }

  if (shouldRedirectToLaunchPage(settings)) {
    return <Navigate to="/launch" replace state={{ from: location.pathname }} />
  }

  return <Outlet />
}
